<template>
  <section>
    <Heading v-if="title" :level="2">{{ title }}</Heading>

    <ul class="download-list">
      <li v-for="item in list" :key="item.url" class="download-list__item">
        <DownloadButton
          class="download-list__button"
          tabindex="0"
          :title="item.title"
          :url="item.url"
        />
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Heading } from '@warrenbrasil/nebraska-web';
import { DownloadButton } from '@/modules/common/components/buttons';

type DownloadItem = {
  title: string;
  description: string;
  url: string;
};

@Component({
  components: { Heading, DownloadButton }
})
export default class DownloadList extends Vue {
  @Prop({ type: Array, required: true })
  public list!: DownloadItem[];

  @Prop({ type: String })
  public title?: string;
}
</script>

<style lang="less" scoped>
.download-list {
  list-style: none;
  margin: 0;
  padding: 0;

  &__button {
    width: 100%;
  }

  &__item + &__item {
    margin-top: @size-spacing-x300;
  }
}
</style>
